import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const isCheckingTokensForEmailConfirmation = createSelector(
    membersState,
    members => members.emailConfirm.isConfirming || members.emailConfirm.token.isValidating
);
